export default "__VITE_ASSET__Pv28_DJw__"